<template>
    <div class="lesson-card col-xl-3 col-lg-4 col-md-6 col-sm-6" @click="$router.push({ name: 'leccion', params: { id: lesson.id } })">
        <div class="course-item h-100">
            <div class="course-thumb set-bg text-right position-relative">
				<img :src="lesson.image_thumbnail" :alt="lesson.title" />
                <div v-if="lesson.progress && lesson.progress.id == 3" class="cover"></div>
                <div v-if="lesson.progress && lesson.progress.id == 3" class="price"><font-awesome-icon icon="check-circle"  /> Completado</div>
            </div>
            <div class="course-info h-100">
                <div class="course-text">
                    <h5>{{ lesson.title }}</h5>
                    <!-- <p>{{ lesson.description }}</p> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'lesson-card',
    props: ['lesson']
}
</script>

<style lang="scss" scoped>
    @import '@/variables.scss';

    .lesson-card {
        margin-bottom: 30px;
    }
    .course-item {
        .course-thumb {
            height: auto;
        }
        overflow: hidden;
        box-shadow: 0 10px 16px 0 rgba(0,0,0,0.07),0 3px 5px 0 rgba(0,0,0,0.07);
        cursor: pointer;
        transform: scale(1);
        transition: all 0.15s linear;
        &:hover {
            transform: scale(1.02);
        }
        .cover {
            height: 100%;
            background-image: linear-gradient($main-color, $main-color-brown);
            opacity: 0.5;
            filter: alpha(opacity=50);
            position: absolute;
            top: 0;
            width: 100%;
        }
        .price {
            position: absolute;
            top: 0;
            right: 0;
            background: #4caf50;
        }
        .course-text {
            padding: 30px !important;
            padding-bottom: 0px !important;
            p {
                margin: 0;
            }
        }
    }
</style>




